import type { ReactNode } from "react";

interface EncabezadoNumeradoProps {
  /** "01", "02"… el cuadradito oscuro de la izquierda. Sin él, no se dibuja. */
  numero?: string;
  titulo: string;
  bajada?: string;
  /** El id del `<h3>`, para que la tarjeta pueda nombrarse con él. */
  idDelTitulo: string;
  /** Lo que va a la derecha: chips de estado y botones. */
  acciones?: ReactNode;
}

/**
 * El encabezado de una tarjeta numerada de la pestaña: cuadradito con el
 * número, título, bajada y, a la derecha, sus acciones.
 *
 * Es el mismo de `TarjetaDeSeccion` en Antecedentes generales, pero sin atarse
 * a las claves de aquella pestaña: la numeración de acá es la de CADA pestaña
 * técnica (01 lista, 02 descripción, 03 notas) y no sale de un índice común.
 */
export function EncabezadoNumerado({
  numero,
  titulo,
  bajada,
  idDelTitulo,
  acciones,
}: EncabezadoNumeradoProps) {
  return (
    <div className="flex flex-wrap items-center gap-3">
      {numero ? (
        <span className="bg-superficie-fija text-superficie-fija-foreground flex size-7 flex-none items-center justify-center rounded-sm font-mono text-xs font-bold">
          {numero}
        </span>
      ) : null}
      <div className="min-w-0">
        <h3 id={idDelTitulo} className="text-h3 text-ink">
          {titulo}
        </h3>
        {bajada ? <p className="text-caption text-ink-muted mt-px text-pretty">{bajada}</p> : null}
      </div>
      {acciones ? <div className="ml-auto flex flex-none items-center gap-2">{acciones}</div> : null}
    </div>
  );
}
